module.exports = __webpack_public_path__ + "static/21-03-29_13-51-39_4823-c6becc846495d3a47e5668d4d1e08686.jpg";